var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDashboardFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0361 3.77594H24.0869C24.9688 3.77599 25.2591 3.95176 25.3516 4.03864C25.4243 4.10707 25.5986 4.33231 25.5986 5.12555V13.6255C25.5986 14.4188 25.4243 14.644 25.3516 14.7125C25.2591 14.7993 24.9688 14.9751 24.0869 14.9752H19.0361C18.1543 14.9751 17.864 14.7993 17.7715 14.7125C17.6987 14.644 17.5244 14.4188 17.5244 13.6255V5.12555C17.5244 4.33231 17.6987 4.10707 17.7715 4.03864C17.864 3.95176 18.1543 3.77599 19.0361 3.77594Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91113 15.0259H10.9619C11.8438 15.026 12.1341 15.2018 12.2266 15.2886C12.2993 15.3571 12.4736 15.5823 12.4736 16.3755V24.8755C12.4736 25.6688 12.2993 25.894 12.2266 25.9625C12.1341 26.0493 11.8438 26.2251 10.9619 26.2252H5.91113C5.02927 26.2251 4.73896 26.0493 4.64648 25.9625C4.57374 25.894 4.39941 25.6688 4.39941 24.8755V16.3755C4.39941 15.5823 4.57374 15.3571 4.64648 15.2886C4.73896 15.2018 5.02927 15.026 5.91113 15.0259Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0361 20.0254H24.0869C24.9688 20.0254 25.2591 20.2012 25.3516 20.2881C25.4243 20.3565 25.5986 20.5818 25.5986 21.375V24.875C25.5986 25.6682 25.4243 25.8935 25.3516 25.9619C25.2591 26.0488 24.9688 26.2246 24.0869 26.2246H19.0361C18.1543 26.2246 17.864 26.0488 17.7715 25.9619C17.6987 25.8935 17.5244 25.6682 17.5244 24.875V21.375C17.5244 20.5818 17.6987 20.3565 17.7715 20.2881C17.864 20.2012 18.1543 20.0254 19.0361 20.0254Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91113 3.77594H10.9619C11.8438 3.77599 12.1341 3.95176 12.2266 4.03864C12.2993 4.10707 12.4736 4.33231 12.4736 5.12555V8.62555C12.4736 9.41879 12.2993 9.64403 12.2266 9.71246C12.1341 9.79934 11.8438 9.97511 10.9619 9.97516H5.91113C5.02927 9.97511 4.73896 9.79934 4.64648 9.71246C4.57374 9.64403 4.39941 9.41879 4.39941 8.62555V5.12555C4.39941 4.33231 4.57374 4.10707 4.64648 4.03864C4.73896 3.95176 5.02927 3.77599 5.91113 3.77594Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDashboardFull);
export default __webpack_public_path__ + "static/media/User-dashboard_full.f0359b77e79dd6079b75bad910bf8b89.svg";
export { ForwardRef as ReactComponent };